// ===========================================
// Hybrid Booking Report Filters Component
// ===========================================
// Filters for hybrid booking analytics
// Phase 2 Priority 12: Reporting & Analytics - Week 4

import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Typography,
  SelectChangeEvent,
} from '@mui/material';
import { HybridBookingReportFilters } from '../../api/reports.api';
import { useTerms } from '../../hooks/useAdmin';

interface HybridBookingFiltersProps {
  filters: HybridBookingReportFilters;
  onChange: (filters: HybridBookingReportFilters) => void;
}

const HybridBookingFilters: React.FC<HybridBookingFiltersProps> = ({ filters, onChange }) => {
  const { data: termsData, isLoading: termsLoading } = useTerms();
  const terms = termsData || [];

  const handleTermChange = (event: SelectChangeEvent<string>) => {
    onChange({
      ...filters,
      termId: event.target.value || undefined,
    });
  };

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Filters
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="term-filter-label">Term</InputLabel>
          <Select
            labelId="term-filter-label"
            id="term-filter"
            value={filters.termId || ''}
            onChange={handleTermChange}
            label="Term"
            disabled={termsLoading}
          >
            {/* The metrics API requires a term — "All Terms" was an option it could never serve. */}
            <MenuItem value="" disabled>
              <em>Select a term</em>
            </MenuItem>
            {terms.map((term) => (
              <MenuItem key={term.id} value={term.id}>
                {term.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Paper>
  );
};

export default HybridBookingFilters;
